
import React from "react";
import FileUploader from "@/components/FileUploader";
import EmailProviderSetup from "@/components/emails/EmailProviderSetup";

interface InitialSetupProps {
  onFileData: (investors: any[], contacts: any[], shouldMerge?: boolean) => void;
  onReprocess: () => void;
  onProviderUpdated: () => void;
}

const InitialSetup: React.FC<InitialSetupProps> = ({
  onFileData,
  onReprocess,
  onProviderUpdated
}) => {
  return (
    <div className="space-y-6">
      <FileUploader 
        onFileData={onFileData}
        onReprocess={onReprocess}
      />
      
      <div>
        <h3 className="text-md font-medium mb-2">API Connections</h3>
        <EmailProviderSetup 
          onProviderUpdated={onProviderUpdated} 
          activeTab="ai"
          showHeader={false}
        />
      </div>
    </div>
  );
};

export default InitialSetup;
